<template>
  <div class="container">
    <div class="row justify-content-center">
      <h1>Thank you for your order!</h1>
    </div>
    <div class="row justify-content-center">
      <redirect :redirectPath="'/dashboard/alpha'" />
    </div>
    <div class="row justify-content-center">
      <img src="resources/images/success.jpg" />
    </div>
  </div>
</template>

<script>
import redirect from '@/components/redirect'

export default {
  components: {
    redirect,
  },
}
</script>
